module.exports = __webpack_public_path__ + "img/showHowActive.d71aa78e.png";